import React from "react";
import { Box } from "@mui/material";
const PageContainer = ({ children, sx }) => {
    return (React.createElement(Box, { sx: Object.assign({ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }, sx) }, children));
};
export default PageContainer;
